import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilService} from '../../service/util.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor(private http: HttpClient, private util: UtilService) {
  }
  ngOnInit(): void {
  }

}
